<template>
  <aside v-if="isWebmaster || tree.length > 0" class="tw-hidden lg:tw-block">
    <div class="tw-mb-6 tw-flex tw-items-center tw-justify-between">
      <h4>Veelgestelde vragen</h4>

      <c-button-icon
        v-if="isWebmaster"
        :icon="toClassicIcon(settingsIcon)"
        text-color="dark"
        flat
      >
        <c-menu auto-close>
          <q-list style="min-width: 200px">
            <q-item
              v-for="(item, index) in menuItems"
              :key="index"
              clickable
              @click="item.onClick"
            >
              <div class="tw-flex tw-items-center tw-gap-4">
                <q-icon size="12px" :name="toClassicIcon(item.icon)" />
                <div>{{ item.label }}</div>
              </div>
            </q-item>
          </q-list>
        </c-menu>
      </c-button-icon>
    </div>

    <c-banner v-if="tree.length === 0" type="warning">
      Er zijn geen veelgestelde vragen gevonden
    </c-banner>

    <nav v-else class="tw-flex tw-flex-col tw-gap-1">
      <template v-for="node in tree" :key="node.uuid">
        <faq-category-nav-row
          :title="node.title"
          :selectable="node.selectable"
          :active="selectedCategoryUuid === node.uuid"
          :is-webmaster="isWebmaster"
          @select="openCategory(node.uuid)"
          @edit="openEditDialog(node.uuid)"
          @delete="openDeleteDialog(node.uuid)"
        />
        <faq-category-nav-row
          v-for="child in node.children"
          :key="child.uuid"
          :title="child.title"
          :selectable="true"
          :active="selectedCategoryUuid === child.uuid"
          :is-webmaster="isWebmaster"
          indent
          @select="openCategory(child.uuid)"
          @edit="openEditDialog(child.uuid)"
          @delete="openDeleteDialog(child.uuid)"
        />
      </template>
    </nav>
  </aside>
</template>

<script setup lang="ts">
import FaqCategoryNavRow from "@/components/knowledge-base/faq/FaqCategoryNavRow.vue";
import { settingsIcon, toClassicIcon } from "common/defaultIcons";
import { useFaqCategoryActions } from "composables/knowledge-base/useFaqCategoryActions";
import { useFaqNavigation } from "composables/knowledge-base/useFaqNavigation";
import { useFaqTree } from "composables/knowledge-base/useFaqTree";
import { checkRole } from "composables/useHelpers";
import { storeToRefs } from "pinia";
import { useFaqStore } from "store/modules/faqStore";
import { computed, onBeforeMount } from "vue";

const faqStore = useFaqStore();
const { categories, selectedCategoryUuid } = storeToRefs(faqStore);
const { menuItems, openEditDialog, openDeleteDialog } = useFaqCategoryActions();
const { openCategory } = useFaqNavigation();
const { tree } = useFaqTree();

const isWebmaster = computed(() => checkRole("webmaster") === true);

onBeforeMount(async () => {
  if (categories.value.length === 0) {
    await faqStore.fetchAll();
  }
});
</script>
